<template>
  <div>
    <ConnectionIndicator/>
    <LoggedOutModal/>
    <transition name="fade" mode="out-in">
      <Election v-if="voterSessionUuid" key="election" />
      <div v-else class="min-vh-100 d-flex flex-column justify-content-between" key="login">
        <div></div>
        <div class="container p-4">
          <Authenticate/>
        </div>
        <div class="dark-blur px-sm-4 py-2 mt-5">
          <div class="container d-flex flex-wrap align-items-center justify-content-between">
            <div v-if="partnerBranding.logo">
              <a :href="partnerBranding.link" target="_blank">
                <img :src="partnerBranding.logo" style="height: 50px"/>
              </a>
            </div>
            <a class="text-decoration-none text-white float-sm-right" href="https://www.assemblyvoting.com" target="_blank">
              <span class="small me-2">{{ $t('js.authenticate.powered_by') }}</span>
              <img  alt="Lumi global" src="@assets/images/av-logo-horizontal-white.png" style="line-height: 0; height: 25px"/>
            </a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapState, mapActions } from "pinia";
import Authenticate from "./Authenticate.vue";
import Election from "./Election.vue";
import ConnectionIndicator from "../shared/ConnectionIndicator.vue";
import LoggedOutModal from "./modals/LoggedOutModal.vue";
import { useVotingSessionStore } from "@/entrypoints/stores/voting_session";
import { useSharedStore } from "@/entrypoints/stores/shared";
import { useFrontendThemeStore } from "@/entrypoints/stores/frontend_theme";
import { useTimingStore } from "@/entrypoints/stores/timing";

export default defineComponent({
  components: {
    ConnectionIndicator,
    Authenticate,
    Election,
    LoggedOutModal
  },
  computed: {
    ...mapState(useVotingSessionStore, ["voterSessionUuid"]),
    ...mapState(useSharedStore, ["election"]),
    ...mapState(useFrontendThemeStore, ["partnerBranding"]),
  },
  methods: {
    ...mapActions(useTimingStore, ["checkTime"]),
  },
  created() {
    this.checkTime();
    document.title = this.election.title[this.$i18n.locale];
  },
});
</script>
